import React from 'react';
import { Empty } from 'antd';
import { renderDetailView } from './detail-views';

interface IPipelineDetailViewProps {
  pipelineId: string;
  scheduleHuman: string;
  displayName: string;
  description?: string | null;
  onClose?: () => void;
}

/**
 * Thin router. Pipeline-type-specific UI lives in `./detail-views/` and is
 * dispatched via the registry there — adding a new pipeline type is one
 * entry, not an extra branch in this component.
 */
const PipelineDetailView: React.FC<IPipelineDetailViewProps> = (props) => {
  const view = renderDetailView(props);

  return view ?? <Empty description='Unknown pipeline type' />;
};

export default PipelineDetailView;
